import configData from "./config.json";
const appEnvName = process.env.APP_ENV_NAME || "prod";
const feedUrl = process.env.FEED_URL ||
    (appEnvName === "dev" ? configData.FEED_URL_DEV : configData.FEED_URL);
const config = {
    ...configData,
    APP_ENV_NAME: appEnvName,
    FEED_URL: feedUrl,
};
export default config;
